// src/components/Header.js
import React from 'react';
import './Header.css';

// Si tu logo está en public/images/logo.png
import logo from '../../src/images/logo.png'; // Ajusta la ruta según donde esté tu logo

function Header() {
  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          {/* Logo izquierdo */}
          <div className="logo-left">
            <img 
              src={logo} 
              alt="Logo OLPEAL" 
              className="header-logo"
            />
          </div>
          
          {/* Logo central/texto */}
          <div className="logo-center">
            <div className="logo-main">OLPEAL</div>
            <div className="logo-subtitle">OLIVOS. PECANES. ALMENDROS</div>
          </div>
          
          {/* Logo derecho */}
          <div className="logo-right">
            <img 
              src={logo} 
              alt="Logo OLPEAL" 
              className="header-logo"
            />
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;